import { ACCOUNT_URL } from '@/utils/constants'

const REQUEST = () => `${ACCOUNT_URL}/login`
const RENEW = () => `${ACCOUNT_URL}/refresh-token`
const LOGOUT = () => `${ACCOUNT_URL}/logout`
const ROLE = () => `${ACCOUNT_URL}/role`
const PERMISSIONS = () => `${ACCOUNT_URL}/permissions`
const PROFILE = () => `${ACCOUNT_URL}/profile`
const RESET_PASSWORD = () => `${ACCOUNT_URL}/reset-password`
const CONFIRM_NEW_PASSWORD = () => `${ACCOUNT_URL}/confirm-new-password`

export default {
  REQUEST,
  RENEW,
  LOGOUT,
  ROLE,
  PERMISSIONS,
  PROFILE,
  RESET_PASSWORD,
  CONFIRM_NEW_PASSWORD
}
